import React from 'react';
import { view } from '@aha-app/react-easy-state';
import DragLayer from 'components/common/DragLayer';
import { type ItemComponentProps } from './types';
import { useObservedState } from 'components/framework/hooks/useObservedState';
import { sharedDragController } from '../controllers/DragController';

type CardDragLayerProps = {
  CardWrapper: React.FC<ItemComponentProps>;
  type?: string;
  types?: string[];
};

const CardDragLayer: React.FC<CardDragLayerProps> = ({
  CardWrapper,
  type,
  types,
}) => {
  const dragItemCount = useObservedState(() =>
    sharedDragController.state.dragging
      ? sharedDragController.dragItems.length
      : 0
  );

  return (
    <DragLayer type={type} types={types}>
      {dragLayerProps => (
        <CardWrapper
          dragItem={dragLayerProps.item}
          selectableItem={dragLayerProps.item}
          dragLayer
          selected={false}
          dragItemCount={dragItemCount}
        />
      )}
    </DragLayer>
  );
};

export default view(CardDragLayer);
